import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import './static/scss/library/bootstrap.min.css';
import './static/scss/desktop/style.scss';
import './static/fonts/ajioicon/jioicons.woff';
import './static/fonts/ajioicon/jioicons.ttf';
import './static/fonts/lora/Lora-Regular.ttf';
import './static/fonts/lora/Lora-Regular.woff';
import './static/fonts/lora/Lora-Bold.ttf';
import './static/fonts/lora/Lora-Bold.woff';
import './static/fonts/source-sans-pro/SourceSansPro-Bold.ttf';
import './static/fonts/source-sans-pro/SourceSansPro-Bold.woff';
import './static/fonts/source-sans-pro/SourceSansPro-Regular.ttf';
import './static/fonts/source-sans-pro/SourceSansPro-Regular.woff';
import './static/fonts/source-sans-pro/SourceSansPro-Semibold.ttf';
import './static/fonts/source-sans-pro/SourceSansPro-Semibold.woff';
import './static/fonts/muli/Muli_Regular.woff';
import './static/fonts/muli/Muli_Bold.woff';
import { BrowserRouter as Router, Route, Link, Switch, Redirect } from 'react-router-dom';
import { getDynamicComponentInfo } from './utils/componentInfo';
import Category from './components/desktop/category/Category';
import IndexPage from './components/desktop/IndexPage';
import Product from './components/desktop/product/Product';
import NotFoundPage from './components/desktop/NotFoundPage';
import ContactUs from './components/staticpages/ContactUs';
import MobileApps from './components/staticpages/MobileApps';
import RetryPayment from './checkout/components/desktop/RetryPayment';
import OrderConfirmation from './checkout/components/desktop/OrderConfirmation';
import LandingPage from './components/desktop/banner/BannerComponent';
import { localStorageClear } from './components/common/LocalStorageClear';
import { eraseCookie, readCookie } from './components/common/Cookie';
import { storageAvailable } from './components/common/storageAvailable';
import { clearLocalStorage, clearCookie } from './utils/clearStorage';
import DynamicImport from './dynamicImport';
import EventsPage from './components/desktop/events/EventsPage';
import CpPage from './components/desktop/capsule/CpPage';
import Capsule from './components/desktop/capsule/Capsule';
import { getDesktopChunk, getCommonChunk } from './asyncImportList';
import Hello from './components/desktop/HelloPage';
import properties from './modules/ajio-util/properties';
import { getHostName } from './utils/sisUtils';
import { FLEEK_STORE } from './constants/constant';
import StorePickup from './components/common/pickup/desktop';
import DesktopTopShopperPage from './refresh/pages/TopShopperPage/DesktopTopShopperPage';
import DesktopAssuredGiftsLayout from './refresh/pages/AssuredGiftsPage/DesktopLandingPage/DesktopAssuredGiftsPage';
import { getPeFlag } from './Flags/selectors';
import FraudFlowWrapper from './userauth/components/FraudFlowComponents/FraudFlowWrapper';
import StoreRedirectBanner from './components/desktop/banner/StoreRedirectBanner';

const SizeGuide = props => (
  <DynamicImport
    load={() => getCommonChunk('sizeguide-v2')}
    {...getDynamicComponentInfo('sizeguide', props, { desktop: true, requireLayout: false })}
  />
);

const Checkout = props => {
  /**
   * method to receive meta information about component
   * getDynamicComponentInfo (name = "", superProps = {}, rest = {})
   * rest = {showLoader = true, componentType = "page", desktop = true}
   */
  const peFlag = _get(props, 'peFlag', 'ON') !== 'OFF';
  const chunkName = peFlag ? 'retry' : 'checkout';
  return (
    <DynamicImport
      load={() => getDesktopChunk(chunkName)}
      {...getDynamicComponentInfo('checkout', props, { requireLayout: false })}
    />
  );
};

const Cart = props => (
  /**
   * method to receive meta information about component
   * getDynamicComponentInfo (name = "", superProps = {}, rest = {})
   * rest = {showLoader = true, componentType = "page", desktop = true}
   */
  <DynamicImport
    load={() => getDesktopChunk('cart')}
    {...getDynamicComponentInfo('cart', props, { requireLayout: false })}
  />
);

const MyAccount = props => {
  /**
   * method to receive meta information about component
   * getDynamicComponentInfo (name = "", superProps = {}, rest = {})
   * rest = {showLoader = true, componentType = "page", desktop = true}
   */
  const { match: { path = '' } = {} } = props;
  const isDeepLinkOdp = path.includes('/rcc');
  const otherParams = {
    component: isDeepLinkOdp && 'order-details'
  };

  return (
    <DynamicImport
      load={() => getDesktopChunk('my-account')}
      {...getDynamicComponentInfo('myaccount', props, isDeepLinkOdp ? { otherParams } : {})}
    />
  );
};

const Shipping = props => (
  /**
   * method to receive meta information about component
   * getDynamicComponentInfo (name = "", superProps = {}, rest = {})
   * rest = {showLoader = true, componentType = "page", desktop = true}
   */
  <DynamicImport
    load={() => getDesktopChunk('shipping')}
    {...getDynamicComponentInfo('shipping', props, { requireLayout: false })}
  />
);

const Wishlist = props => (
  /**
   * method to receive meta information about component
   * getDynamicComponentInfo (name = "", superProps = {}, rest = {})
   * rest = {showLoader = true, componentType = "page", desktop = true}
   */
  <DynamicImport
    load={() => getDesktopChunk('wishlist')}
    {...getDynamicComponentInfo('wishlist', props, { requireLayout: false })}
  />
);

const Selfcare = props => (
  /**
   * method to receive meta information about component
   * getDynamicComponentInfo (name = "", superProps = {}, rest = {})
   * rest = {showLoader = true, componentType = "page", desktop = true}
   */
  <DynamicImport
    load={() => getDesktopChunk('selfcare')}
    {...getDynamicComponentInfo('selfcare', props, { requireLayout: false })}
  />
);

const ItemDetails = props => (
  /**
   * method to receive meta information about component
   * getDynamicComponentInfo (name = "", superProps = {}, rest = {})
   * rest = {showLoader = true, componentType = "page", desktop = true}
   */
  <DynamicImport
    load={() => getDesktopChunk('itemdetails')}
    {...getDynamicComponentInfo('itemdetails', props, { requireLayout: false })}
  />
);

const OffersChunk = props => (
  <DynamicImport
    load={() => getDesktopChunk('offers')}
    {...getDynamicComponentInfo('offers', props, { requireLayout: false })}
  />
);

const PromoGuidelines = props => (
  <DynamicImport
    load={() => getDesktopChunk('couponBonanza')}
    {...getDynamicComponentInfo('couponBonanza', props, { requireLayout: false })}
  />
);

const UserAuth = props => (
  /**
   * method to receive meta information about component
   * getDynamicComponentInfo (name = "", superProps = {}, rest = {})
   * rest = {showLoader = true, componentType = "page", desktop = true}
   */
  <DynamicImport
    load={() => getDesktopChunk('auth')}
    {...getDynamicComponentInfo('userauth', props, { requireLayout: false })}
  />
);
const SpinTheWheelChunk = props => (
  <DynamicImport
    load={() => getDesktopChunk('SpinTheWheel')}
    {...getDynamicComponentInfo('SpinTheWheel', props, { requireLayout: false })}
  />
);

// const OrderConfirmation = (props) => (
//   /**
//    * method to receive meta information about component
//    * getDynamicComponentInfo (name = "", superProps = {}, rest = {})
//    * rest = {showLoader = true, componentType = "page", desktop = true}
//    */
//   <DynamicImport
//     load={() => getDesktopChunk("order-confirmation")}
//     {...getDynamicComponentInfo("order-confirmation", props, { requireLayout: false })}
//   />
// )

if (storageAvailable('localStorage')) {
  var coreSelected = localStorage.getItem('categoryType') == 'core';
  var catPath = localStorage.getItem('categoryPath');
  var noncoreSelected = localStorage.getItem('categoryType') == 'noncore';
  var corePathExists = !!(catPath != '' && catPath != null);
}

function checkLastSelectedDate() {
  if (coreSelected) {
    var dateToday = new Date();
    var moreThanMonth = localStorageClear(localStorage.getItem('coreSelectedOn'), dateToday);
    if (moreThanMonth) {
      coreSelected = false;
    }
  }
}

function setSelectedCategory() {
  if (noncoreSelected) {
    localStorage.setItem('categoryClicked', catPath.slice(1));
  }
  return true;
}

const AuthenticatedRoute = ({ component: Component, ...rest }) => {
  let { location: { pathname: referrer = '', search } = {} } = window;
  if (referrer?.includes('/my-account') && search?.includes('referrer=email')) {
    return <Redirect to="/my-account/update-profile" />
  }
  referrer = referrer.slice(1);
  let redirectURI = '/login';

  if (referrer) {
    redirectURI = `${redirectURI}?referrer=${referrer}`;
  }
  let user = readCookie('U');

  return (
    <Route
      {...rest}
      render={props =>
        user && user != 'anonymous' ? (
          <Component {...props} />
        ) : (
          (window.location.href = redirectURI)
        )
      }
    />
  );
};

const routes = props => {
  const { location: { href = '' } = {} } = window;
  const store = getHostName(href);
  // if(store === FLEEK_STORE && ) {
  //   return <StoreRedirectBanner/>
  // }
  
  return (
    <Router>
      <Switch>
        <Route
          exact
          path="/"
          render={() => {
            if (window.location.href.includes('clear')) {
              if (storageAvailable('localStorage')) {
                clearLocalStorage([
                  'categoryClicked',
                  'categoryType',
                  'categoryPath',
                  'coreSelectedOn'
                ]);
              }
              clearCookie(['categoryClicked', 'categoryType', 'categoryPath', 'coreSelectedOn']);
              window.location = '/';
            }
            let { location: { href = '' } = {} } = window;
            let store = '';
            store = getHostName(href);
            if (storageAvailable('localStorage')) {
              checkLastSelectedDate();
               if(store && store === FLEEK_STORE) { // Fleek will not be there for the home page
               return <StoreRedirectBanner/> 
              }
              if (store) {
                return <LandingPage />;
              } else if (
                (coreSelected && setSelectedCategory()) ||
                (corePathExists && noncoreSelected)
              ) {
                window.location = catPath;
                return;
              }
              return <LandingPage />;
            }
            return <LandingPage />;
          }}
        />
        <Route
          exact
          path="/home"
          render={() => {
            if (storageAvailable('localStorage'))
              clearLocalStorage([
                'categoryClicked',
                'categoryType',
                'categoryPath',
                'coreSelectedOn'
              ]);
            clearCookie(['categoryClicked', 'categoryType', 'categoryPath', 'coreSelectedOn']);
            window.location = '/';
          }}
        />
        <Route path="/restore-phonenumber" component={UserAuth} />
        <Route path="/c/:cid" component={Category} />
        <Route path="/fc/:cid" component={Category} />
        <Route path="/:categoryName/c/:cid" component={Category} />
        <Route path="/s/:cid" component={Category} />
        <Route exact path="/:str/p/:id" component={Product} />
        <Route exact path="/p/:id" component={Product} />
        <Route
          path="/search/:cid"
          render={() => {
            let { location: { href = '' } = {} } = window;
            return <Category />;
          }}
        />
        <Route
          path="/search"
          render={() => {
            let { location: { href = '' } = {} } = window;
            let store = getHostName(href);
            let url = window.location.search;
            url = url.replace('?', '');
            return <Category />;
          }}
        />
        <Route
          path="/find/:cid"
          render={() => {
            let { location: { href = '' } = {} } = window;
            let store = getHostName(href);
            return <Category />;
          }}
        />
        <Route
          path="/find"
          render={() => {
            let { location: { href = '' } = {} } = window;
            let store = getHostName(href);
            return <Category />;
          }}
        />
        <Route path="/b/:cid" component={Category} />
        <Route path="/fb/:cid" component={Category} />
        <Route path="/s1/:cid" component={Category} />
        <Route path="help/contactus" component={ContactUs} />
        <Route path="/mobile-apps" component={MobileApps} />
        <Route path="/shop/:catstr" component={LandingPage} />
        <Route path="/leaderboard" component={EventsPage} /> // route for events page
        <Route path="/cp/:cid" component={CpPage} />
        <Route path="/capsule/:cid" component={Capsule} />
        <Route path="/hello" component={Hello} />
        <Route path="/cart" component={Cart} />
        <Route path="/offers" component={OffersChunk} />
        <Route path="/store-pickup" component={StorePickup} />
        <Route path="/store-return" component={StorePickup} />
        <Route
          path="/login"
          render={() => {
            let { location: { href = '' } = {} } = window;
            let user = readCookie('U');
           
              return <UserAuth />;
            
          }}
        />
        <Route path="/verify/:token" component={UserAuth} />
        <Route path="/sizeguide-v2" component={SizeGuide} />
        <AuthenticatedRoute path="/my-account/:page" component={MyAccount} />
        <AuthenticatedRoute path="/my-account" component={MyAccount} />
        <AuthenticatedRoute path="/rcc" component={MyAccount} />
        <AuthenticatedRoute path="/checkout" component={() => <Checkout {...props} />} />
        <AuthenticatedRoute
          path="/order/retrypayment/:id"
          component={() => <RetryPayment {...props} />}
        />
        {/* <Route path="/checkout" component={Checkout} /> */}
        {/* <Route path="/order/retrypayment/:id" component={Checkout} /> */}
        <AuthenticatedRoute path="/wishlist" component={Wishlist} />
        <AuthenticatedRoute path="/shipping" component={Shipping} />
        <Route path="/selfcare" component={Selfcare} />
        <AuthenticatedRoute path="/itemDetails" component={ItemDetails} />
        <AuthenticatedRoute path={["/order/confirm/:id", "/order/confirm/:id/:paymentMode"]} component={OrderConfirmation} />
        <Route
          exact
          path="/CouponBonanza-Static"
          render={() => {
            window.location = '/couponsbonanza';
          }}
        />
        <Route path="/couponsbonanza" component={PromoGuidelines} />
        <Route path="/games/:gameType" component={SpinTheWheelChunk} />
        <Route path="/top-shopper" component={DesktopTopShopperPage} />
        <Route path="/assured-gifts" component={DesktopAssuredGiftsLayout} />
        <Route component={NotFoundPage} />
      </Switch>
    </Router>
  )
};

const mapStateToProps = state => {
  const { flags = {} } = state;
  return {
    peFlag: getPeFlag(flags)
  };
};

export default connect(mapStateToProps)(routes);
